<template>
  <div class="after-pay-root" :style="cssVars()">
    <div class="after-pay-con">
      <div>
        <img v-if="pkgName" :src="getMatchImg('app-logo', pkgName)" />
      </div>
      <MyPLabel class="page-tips" :str="$t('lang.commonM.k348')" :numsOption="[{ value: pkgName }]" />

      <button @click="handleToApp">
        <img src="@/assets/packageAssets/common/arrow10.png" />
      </button>
      <p class="btn-tips">{{ $t('lang.commonM.k349') }}</p>
    </div>
  </div>
</template>

<script>
import { getPackageNamePayBack } from '@/api/imee'
import { getQueryParams } from '@/utils/common.js'
import { pageCssVars } from './z-style-cfg.js'

import BaseConfig from '@/config/base.js'

export default {
  mixins: [pageCssVars],
  data() {
    return {
      pkgName: '',
      originPkgName: ''
    }
  },
  methods: {
    handleToApp() {
      if (BaseConfig.schemaMap[this.pkgName] || BaseConfig.schemaMap.default) {
        const jumpUrl = `${BaseConfig.schemaMap[this.pkgName] || BaseConfig.schemaMap.default}${this.originPkgName}`
        window.location.href = jumpUrl
      }
    }
  },
  created() {
    if (this.$route.query.packageName) {
      this.pkgName = BaseConfig.packageNameMap[this.$route.query.packageName]
      this.originPkgName = this.$route.query.packageName
      setTimeout(() => {
        this.handleToApp()
      }, 500)
    }
    // url中无包信息
    else {
      try {
        const queryObj = getQueryParams(window.location.href)
        if (queryObj && Object.keys(queryObj).length) {
          getPackageNamePayBack(queryObj).then((resData) => {
            if (resData && resData.appPackageName && BaseConfig.packageNameMap[resData.appPackageName]) {
              this.originPkgName = resData.appPackageName
              this.pkgName = BaseConfig.packageNameMap[resData.appPackageName]
              setTimeout(() => {
                this.handleToApp()
              }, 500)
            }
          })
        }
      } catch (err) {
        console.log('try catch err:', err)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.after-pay-root {
  width: 100vw;
  min-height: 100vh;
  .after-pay-con {
    padding: 0 20px 100px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div {
      width: 80px;
      height: 80px;
      margin-top: 30vh;
      font-size: 0;
      background-color: #eaeaea;
      border-radius: 16px;
      img {
        width: 100%;
      }
    }
    .page-tips {
      color: var(--Fonts-Font-1, #333);
      text-align: center;
      font-family: 'Inter-TightRegular';
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      margin-top: 24px;
    }

    button {
      width: 255px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 100px;
      font-size: 40px;
      font-weight: bold;
      border-radius: 56px;
      background: var(--button-color, #eaeaea);
      color: #ffffff;

      img {
        width: 24px;
        height: 24px;
      }
    }

    .btn-tips {
      color: var(--Fonts-Font-3, #b2b2b2);
      text-align: center;
      font-family: 'Inter-TightRegular';
      font-size: 15px;
      font-style: normal;
      font-weight: 400;
      line-height: 18px;

      margin-top: 12px;
    }
  }
}
</style>
